import {GetProvidersListParams} from 'domain/usecases/private/authorizations/get-providers-list';
import {makeGetProvidersList} from 'main/factories/usecases/private/authorizations/get-providers-list-factory';

export const getProvidersList = async (params: GetProvidersListParams) => {
	try {
		const response = await makeGetProvidersList().get(params);

		if (!response) {
			return {
				content: [],
				totalElements: 0,
			};
		}

		const enrichedContent = response.content.map(provider => ({
			...provider,
			idUnico: `${provider?.cdPrestador}${provider?.nmEndereco?.trim().toLowerCase()}`,
		}));

		return {
			...response,
			content: enrichedContent,
		};
	} catch (error) {
		throw new Error();
	}
};
